import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Schools } from '../models/schools';
import { distinct, map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SchoolsService {
  apiUrl = environment.apiUrl;
  private schoolUrl = this.apiUrl + '/schoolapi/schools';

  public errorMessage: string;
  error: any;

  public selectedSchool = new BehaviorSubject<Schools>(null);
  public selectedSchool$ = this.selectedSchool.asObservable().pipe(distinct((S: Schools) => S && S.schoolId));

  constructor(private http: HttpClient) {}

  // search
  setSelectedSchool(school: Schools): void {
    this.selectedSchool.next(school);
  }
  // get ALL schools, for school search list
  getSchools(additionalParams?, offset?, limit?) {
    const nonSpecific = '=0&limit=1000';
    const specificParam = '=0&limit=1';
    let param;
    if (additionalParams !== null) {
      param = specificParam;
    } else if (additionalParams === null) {
      param = nonSpecific;
    }
    return this.http
      .get<any>(`${this.schoolUrl}?${additionalParams ? additionalParams + '&' : ''}offset + ${param}`, {
        observe: 'response'
      })
      .pipe(
        map((response: any) => {
          return response.body;
        }),
        catchError(error => {
          this.error = error;
          console.log(error);
          return throwError(error);
        })
      );
  }
  // get specific school by school ID
  getSchoolsById(schoolId: string) {
    return this.http
      .get<any>(`${this.schoolUrl}/${schoolId}`, {
        observe: 'response'
      })
      .pipe(
        map((response: any) => {
          return response.body.data;
        }),
        catchError(error => {
          this.error = error;
          console.log(error);
          return throwError(error);
        })
      );
  }
  // update school information
  updateSchool(selectedSchoolId: string, obj: any) {
    console.log(obj);
    return this.http
      .put<any>(`${this.schoolUrl}/${selectedSchoolId}/`, obj, {
        observe: 'response'
      })
      .pipe(
        map((response: any) => {
          return response.body.data;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }
  // post new school
  postNewSchool(obj: any) {
    console.log(obj);
    return this.http
      .post<any>(`${this.schoolUrl}`, obj, {
        observe: 'response'
      })
      .pipe(
        map((response: any) => {
          return response.body.data;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }
}
